import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { setFile } from "../redux/creators/fileCreators";
import { getProductType } from "../redux/creators/threekitCreators";

export default function UploadButton() {
  const { file, currentNode, productType } = useSelector((state) => ({
    file: state.files.file,
    currentNode: state.playerState.currentNode,
    productType: getProductType(state),
  }));
  const dispatch = useDispatch();
  const addFile = (file) => dispatch(setFile(file));
  const fileInput = React.createRef();

  const shouldPromptUpload = () => {
    return (
      (productType !== "wall-display" && productType !== "collage") ||
      currentNode !== ""
    );
  };

  const uploadButton = () => {
    return (
      <div className="uploadButton">
        <div className="threekit-options-section">
          <label className="custom-file-upload">
            <input
              id="threekit-fileupload"
              type="file"
              name="fileupload"
              accept="image/png, image/jpg, image/jpeg"
              ref={fileInput}
              onChange={(e) => addFile(e.target.files[0])}
            />
            {file ? file.name : "Upload Your Image"}
          </label>
        </div>
      </div>
    );
  };

  const clickPanelPrompt = () => {
    return (
      <div className="uploadButton">
        <div className="threekit-options-section">
          <label className="custom-file-upload">
            <input
              id="threekit-fileupload"
              type="file"
              name="fileupload"
              accept="image/png, image/jpg, image/jpeg"
              ref={fileInput}
              // onChange={(e) => addFile(e.target.files[0])}
              disabled
            />
            Click a Panel to Begin Uploading Image
          </label>
        </div>
      </div>
    );
  };

  return shouldPromptUpload() ? uploadButton() : clickPanelPrompt();
}
